import dayjs from "dayjs";
import 'dayjs/locale/zh-cn'; // 确保导入了中文语言包  
import 'dayjs/locale/en';
export function debounce(fn, delay = 200) {
    let timer;
    return function (...args) {
        if (timer !== undefined) {
            clearTimeout(timer)
            timer = undefined
        }
        const that = this;
        timer = setTimeout(() => {
            fn.apply(that, args)
            clearTimeout(timer)
            timer = undefined
        }, delay)
    }
}

export function getSiteTile(){
    return window.location.href.includes("/en")? "has been the sponsor of Hong Kong Web3 Festival 2026" : "将助力2026香港Web3嘉年华";
}
export function shareToTw(txt){
    const local = window.location.href;
    // let cardlink = tw;
    // if(img){
    //     cardlink+= `?imgs=${img}`
    // }
    let url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(txt)}&url=${encodeURIComponent(local)}`;
    window.open(url,"_blank")
}

export function getTransformValue(element) {
    // 使用getComputedStyle获取元素的最终样式  
    const computedStyle = window.getComputedStyle(element);
    const transformValue = computedStyle.transform || computedStyle.getPropertyValue('transform');
    // 返回transform值  
    return transformValue;
}  
export function getWindowSize(){
    // return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth)
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth)
}

export function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {  
    if (typeof date === 'number') {  
        date = new Date(date);  
    }  
  
    if (!(date instanceof Date)) {  
        console.error('Invalid date');  
        return '';  
    }  
  
    const map = {  
        'M+': date.getMonth() + 1, // 月份  
        'd+': date.getDate(),      // 日  
        'h+': date.getHours() % 12, // 小时 (12小时制)  
        'H+': date.getHours(),     // 小时 (24小时制)  
        'm+': date.getMinutes(),   // 分  
        's+': date.getSeconds(),   // 秒  
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度  
        'S': date.getMilliseconds() // 毫秒  
    };  
  
    format = format.replace(/([yMdhHmsqS])+/g, function(all, t){  
        let v = map[t];  
        if (v !== undefined) {  
            if (all.length > 1) {  
                v = '0' + v;  
                v = v.substr(v.length-2);  
            }  
            return v;  
        } else if (t === 'y+') {  
            return (date.getFullYear() + '').substr(4 - all.length);  
        }  
        return all;  
    });  
  
    return format;  
}  

export function format(date, lang){
    if(lang === "zh"){
        dayjs.locale('zh-cn'); 
        return dayjs(date).format('MM月DD日')
    }else{
        dayjs.locale('en');
        return dayjs(date).format('MMMM DD')
    }
}

export function createId() {
    // 返回一个随机的36进制数（0-9，a-z），然后截取2到10位
    return Math.random().toString(36).substr(2, 9);
}

export const tagColors = ["#EE7EBC", "#85BAF9", "#377CF6"];

export function changeUrlLang(lang = 'zh'){
    let currentPath = window.location.pathname;
  
  // 检查当前是否是英文路径
  if (lang === 'en') {
    // 切换到中文
    currentPath = currentPath.replace("/en", '/zh');
  } 
  // 检查当前是否是中文路径
  else {
    // 切换到英文
    currentPath = currentPath.replace("/zh", '/en');
  }
  window.location.href = currentPath;
//   window.location.reload();
}